import { ArrowRight, Mail } from "lucide-react";
import { school, images, vehicle } from "../mock/mock";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden" data-testid="cta-section">
      <img src={images.uppsala} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0B2545]/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B2545] via-[#0B2545]/80 to-transparent" />
      <div className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] rounded-full bg-[#ffce3a]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#ffce3a]/15 border border-[#ffce3a]/40 text-[#ffce3a] font-bold tracking-[0.18em] text-xs uppercase">
            Kom igång idag
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-5 leading-[1.1]">
            Redo att börja din <span className="text-[#ffce3a]">körkortsresa?</span>
          </h2>
          <p className="text-lg text-slate-300 mt-5 max-w-lg leading-relaxed">
            Boka och omboka dina lektioner digitalt – när det passar dig, dygnet runt. Eller hör av dig så hjälper vi dig hela vägen till körkortet.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-9">
            <a href={school.bookingUrl} target="_blank" rel="noopener noreferrer" data-testid="cta-book-btn" className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-[#ffce3a] text-[#0B2545] font-extrabold text-lg hover:bg-[#ffd85f] transition-colors shadow-xl shadow-[#ffce3a]/20">
              Boka online
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a href={`mailto:${school.email}`} data-testid="cta-mail-btn" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl border border-white/25 bg-white/5 backdrop-blur-sm text-white font-semibold hover:bg-white/15 transition-colors">
              <Mail size={18} /> {school.email}
            </a>
          </div>
        </div>
        <div className="relative hidden lg:block">
          <div className="absolute inset-x-10 bottom-6 h-16 rounded-full bg-black/40 blur-2xl" />
          <img src="/img/car-transparent.png" alt={vehicle.name} className="relative w-full h-auto drop-shadow-2xl -rotate-2 hover:rotate-0 transition-transform duration-700" />
        </div>
      </div>
    </section>
  );
}
